// refresh.service.ts
import { Injectable } from '@angular/core';
import { filter, Observable, startWith, Subject } from 'rxjs';

export enum EducatorEvent {
  DemographicsChange,
  TranscriptAssociated,
  DocumentDeleted,
  DocumentChanged,
  Merge,
  ApplicationDeleted,
  FingerprintDisassociated,
  SpecialProgramChange,
  ManualIUReviewCompleted,
}

@Injectable({
  providedIn: 'root',
})
export class EducatorEventBusService {
  private refreshTrigger = new Subject<EducatorEvent>();

  listenFor(...events: EducatorEvent[]): Observable<EducatorEvent | null> {
    return this.refreshTrigger.pipe(
      filter((currentEvent) => events.some((e) => e === currentEvent)),
      startWith(null),
    );
  }

  dispatchEvent(event: EducatorEvent) {
    this.refreshTrigger.next(event);
  }
}
